import React from 'react';
import PropTypes from 'prop-types';
import HeaderWithBreadcrumbs from '../../componentsV2/Headers/HeaderWithBreadcrumbs';
import { DialogsProvider, ToastProvider } from '../../providers';
import { withContextProvider } from '../../hoc';
import ImportsPage from './ImportsPage';
import { getRoleChecks } from '../../utils/roles';

const ImportsPageWrapper = ({ organizationId, currentUserRole }) => {
  const { isManager } = getRoleChecks(currentUserRole);
  return (
    <DialogsProvider>
      <>
        <header>
          <HeaderWithBreadcrumbs links={[{ href: '/imports', name: 'Imports' }]} name="reports" label="Imports" />
        </header>
        <main>
          <ImportsPage organizationId={organizationId} isManager={isManager} />
        </main>
      </>
    </DialogsProvider>
  );
};

ImportsPageWrapper.propTypes = {
  organizationId: PropTypes.number.isRequired,
  currentUserRole: PropTypes.string.isRequired,
};

export default withContextProvider(ToastProvider)(ImportsPageWrapper);
